import useSWR from "swr";
/**
 * A cache-only SWR wrapper for domain hooks.
 *
 * This hook is designed to read from the SWR cache WITHOUT triggering any network requests.
 * It should be used in domain hooks that consume data already hydrated by PublicDataHydrator
 * or AuthenticatedDataHydrator.
 *
 * Key features:
 * - All revalidation is disabled
 * - No fetcher is provided (enforces cache-only behavior)
 * - Data must be pre-populated by hydrator components
 *
 * @example
 * ```tsx
 * // In a domain hook
 * const { data, error, isLoading } = useCachedSWR<CustomerInfoType>(
 *   AUTH_SWR_KEYS.CUSTOMER_INFO
 * );
 * ```
 *
 * @param key - The SWR cache key (from PUBLIC_SWR_KEYS or AUTH_SWR_KEYS)
 * @param options - Optional SWR configuration (revalidation options will be overridden)
 * @returns SWR response object with cached data
 */
export function useCachedSWR(key, options) {
    return useSWR(key, null, Object.assign(Object.assign({}, options), { 
        // Enforce cache-only behavior - these cannot be overridden
        revalidateOnMount: false, revalidateOnFocus: false, revalidateOnReconnect: false, revalidateIfStale: false, dedupingInterval: Infinity }));
}
